import { Component, OnDestroy, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Html5Qrcode } from 'html5-qrcode';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'qr-scanner-dialog',
    templateUrl: './qr-scanner-dialog.component.html',
    encapsulation: ViewEncapsulation.None
})
export class QrScannerDialogComponent implements AfterViewInit, OnDestroy
{
    scanning: boolean = false;
    scanning_complete: boolean = false;
    error_message: string = '';

    private _html5QrCode: Html5Qrcode | null = null;

    constructor(
        private _dialogRef: MatDialogRef<QrScannerDialogComponent>,
        private _authService: AuthService
    ) {}

    ngAfterViewInit(): void
    {
        this._startScanner();
    }

    ngOnDestroy(): void
    {
        this._stopScanner();
    }

    private _startScanner(): void
    {
        this._html5QrCode = new Html5Qrcode('qr-reader');

        this._html5QrCode.start(
            { facingMode: 'environment' },
            { fps: 10, qrbox: { width: 250, height: 250 } },
            (decodedText) => this._onScanSuccess(decodedText),
            () => {} // ignore scan failures (no QR found in frame)
        ).catch((err) => {
            this.error_message = 'Unable to access camera. Please grant camera permission and try again.';
        });
    }

    private _stopScanner(): void
    {
        if (this._html5QrCode) {
            this._html5QrCode.stop().catch(() => {});
            this._html5QrCode = null;
        }
    }

    private _onScanSuccess(decodedText: string): void
    {
        if (this.scanning || this.scanning_complete) {
            return;
        }

        let parsed: { sessionId: string; secret: string };
        try {
            parsed = JSON.parse(decodedText);
            if (!parsed.sessionId || !parsed.secret) {
                throw new Error('Invalid QR data');
            }
        } catch {
            this.error_message = 'Invalid QR code. Please scan a Desktop Attendant sign-in QR code.';
            return;
        }

        this.scanning = true;
        this._stopScanner();

        this._authService.authorizeQrSession(parsed.sessionId, parsed.secret)
            .subscribe({
                next: () => {
                    this.scanning = false;
                    this.scanning_complete = true;

                    // Auto-close dialog after 2 seconds
                    setTimeout(() => this._dialogRef.close(true), 2000);
                },
                error: () => {
                    this.scanning = false;
                    this.error_message = 'Failed to authorize session. It may have expired. Please try again.';
                }
            });
    }
}
